var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 12C65.3737 12 60 17.3737 60 24C60 30.6262 65.3737 36 72 36C78.6262 36 84 30.6262 84 24C84 17.3737 78.6262 12 72 12Z",
    fill: "url(#paint0_linear_8447_156779)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9811 68.8613C75.4498 63.8025 74.1148 58.1363 74.1148 52.4813V42.0225C74.1148 41.4675 74.0923 40.9163 74.0586 40.365C73.3836 40.4513 72.6973 40.5 71.9998 40.5C70.6273 40.5 69.2923 40.3275 68.0136 40.0125C68.0811 40.6763 68.1148 41.3438 68.1148 42.0263V52.485C68.1148 59.07 69.6711 65.6625 72.6148 71.55L72.8661 72.0488H23.1336L23.3848 71.55C26.3286 65.6625 27.8848 59.07 27.8848 52.485V42.0263C27.8848 30.9338 36.9073 21.9113 47.9998 21.9113C50.6548 21.9113 53.1936 22.4325 55.5148 23.3738C55.6161 20.6888 56.3623 18.165 57.6036 15.9563V6H38.3961V17.745C28.7361 21.5813 21.8848 31.0125 21.8848 42.0225V52.4813C21.8848 58.1363 20.5461 63.8025 18.0186 68.8613L13.4248 78.045H35.0923V78.3488C35.0923 85.4663 40.8823 91.2563 47.9998 91.2563C55.1173 91.2563 60.9073 85.4663 60.9073 78.3488V78.045H82.5748L77.9848 68.8613H77.9811ZM44.3961 12H51.6036V16.1625C50.4261 15.9975 49.2223 15.9075 47.9998 15.9075C46.7773 15.9075 45.5736 15.9975 44.3961 16.1625V12ZM54.9073 78.3488C54.9073 82.1588 51.8098 85.2563 47.9998 85.2563C44.1898 85.2563 41.0923 82.1588 41.0923 78.3488V78.045H54.9073V78.3488Z",
    fill: "url(#paint1_linear_8447_156779)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8447_156779",
    x1: 60.6279,
    y1: 13.8836,
    x2: 80.4021,
    y2: 33.6579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7052D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#CA5AFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8447_156779",
    x1: 13.4248,
    y1: 6,
    x2: 65.3224,
    y2: 100.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272135,
    stopColor: "#34263B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658079,
    stopColor: "#13172C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.e66792b20e6625f94488b0da9251f377.svg";
export { ForwardRef as ReactComponent };